import { AppRoutes } from "../../../../AppRoutes";

/**
 * Configuração de menu específica para BEE
 *
 * Exemplo: Bee tem alguns menus adicionais e esconde o menu de Benefits
 */

export const agap2MenuConfig = {
    // Items adicionais específicos para Bee
    additionalItems: [],

    hideItems: [AppRoutes.whatsappGroupList.key, AppRoutes.quizBuilder.key, AppRoutes.templateList.key, AppRoutes.welcomeSessionList.key, AppRoutes.followUpEventStatusList.key],

    // Modificações em itens existentes
    modifyItems: [],
};